import { Link } from 'react-router-dom';
import {
  IconNeedleThread,
  IconLeaf,
  IconClock,
  IconShieldCheck,
} from '@tabler/icons-react';
import { useSiteContent } from '../context/SiteContentContext';
import { useProducts } from '../context/ProductsContext';
import { getPageImage } from '../lib/imageStore';
import GuyanaStripe from '../components/layout/GuyanaStripe';
import PageTitle from '../components/ui/PageTitle';
import FadeIn from '../components/ui/FadeIn';
import ProductCard from '../components/ui/ProductCard';
import { HomePageSkeleton } from '../components/ui/Skeleton';
import './HomePage.css';

var trustIcons = [IconNeedleThread, IconLeaf, IconClock, IconShieldCheck];

export default function HomePage() {
  var content = useSiteContent();
  var c = content.c;
  var contentLoading = content.loading;
  var productsCtx = useProducts();
  var products = productsCtx.products;
  var productsLoading = productsCtx.loading;

  var heroImg = getPageImage('hero_main');
  var storyImg = getPageImage('story_portrait');

  if (contentLoading || productsLoading) {
    return <HomePageSkeleton />;
  }

  var trustPoints = [c('trust_1'), c('trust_2'), c('trust_3'), c('trust_4')];
  var headline = c('hero_headline', 'Leather built to last a lifetime.');

  return (
    <>
      <PageTitle />
      <FadeIn>
        <section className="hero">
          <div className="hero__content">
            <span className="hero__eyebrow">{c('hero_eyebrow')}</span>
            <h1 className="hero__headline">
              {headline.includes('last a lifetime') ? (
                <>{headline.split('last a lifetime')[0]}<em>last a lifetime.</em></>
              ) : (
                headline
              )}
            </h1>
            <p className="hero__sub">{c('hero_subtext')}</p>
            <div className="hero__ctas">
              <Link to="/shop" className="btn-primary">{c('hero_cta_primary')}</Link>
              <Link to="/about" className="btn-ghost">{c('hero_cta_secondary')}</Link>
            </div>
          </div>
          {heroImg ? (
            <div className="hero__image">
              <img src={heroImg} alt="Hero" />
            </div>
          ) : (
            <div className="hero__image-placeholder">Your hero photo here</div>
          )}
        </section>
      </FadeIn>

      <GuyanaStripe />

      <div className="trust-bar">
        {trustPoints.map(function(point, i) {
          var Icon = trustIcons[i];
          return (
            <span className="trust-bar__item" key={i}>
              <Icon size={14} className="trust-bar__icon" /> {point}
            </span>
          );
        })}
      </div>

      <section className="home-collection container">
        <div className="section-header">
          <span className="section-header__eyebrow">{c('collection_eyebrow')}</span>
          <h2 className="section-header__title">{c('collection_heading')}</h2>
        </div>

        <div className="product-grid">
          {products.map(function(product) {
            return <ProductCard product={product} key={product.id} />;
          })}
        </div>
      </section>

      <FadeIn>
        <section className="story-section">
          {storyImg ? (
            <div className="story-section__img story-section__img--has-photo">
              <img src={storyImg} alt="Andre" />
            </div>
          ) : (
            <div className="story-section__img">Your portrait here</div>
          )}
          <div className="story-section__text">
            <span className="story-section__eyebrow">{c('story_eyebrow')}</span>
            <h2 className="story-section__heading">{c('story_heading')}</h2>
            <p className="story-section__body">{c('story_body')}</p>
            <Link to="/about" className="story-section__link">
              {c('story_link_text') + ' \u2192'}
            </Link>
          </div>
        </section>
      </FadeIn>
    </>
  );
}